module.exports = __webpack_public_path__ + "img/product_41.c65defc.webp";